/**
 * @desc 平台站点-分页查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.PlatformSiteResponseDto>
>;
export function request(
  params: API.basics.platformSite.pageList.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/platformSite/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
